import { reduxForm, change, formValueSelector } from 'redux-form';
import { connect } from 'react-redux';
import { createInventoryRepackage, editInventoryRepackage, fetchInventoryRepackageDetail } from '../../actions/inventoryRepackages_actions';
import { fetchInventories } from '../../actions/inventoryConverts_actions';

import InventoryRepackageForm from '../../components/Inventories/inventoryRepackageForm';

const validate = values => {
  const errors = {}
  if (!values.Quantity) {
      errors.Quantity = 'Required'
  }
  if (!values.RepackagedQuantity) {
      errors.RepackagedQuantity = 'Required'
  }
  return errors
}

let inventoryRepackageForm = reduxForm({
    form: 'inventoryRepackageForm',
    validate
})(InventoryRepackageForm);

const selector = formValueSelector('inventoryRepackageForm')

function mapStateToProps(state) {
    const quantityValue = selector(state, 'Quantity');
    const repackagedQuantityValue = selector(state, 'RepackagedQuantity');
    const postingDate = selector(state, 'PostingDate');
    const note = selector(state, 'Note');
    return {
        quantityValue,
        repackagedQuantityValue,
        postingDate,
        note,

        currentInventoryRepackage: state.inventoryRepackages.currentInventoryRepackage,
        currentInventoryRepackageDetail: state.inventoryRepackages.currentInventoryRepackageDetail,
        detailIsLoading: state.inventoryRepackages.detailIsLoading,
        detailError: state.inventoryRepackages.detailError,
        initialValues: state.inventoryRepackages.currentInventoryRepackageDetail,
        isCreating: state.inventoryRepackages.isCreating,
        createError: state.inventoryRepackages.createError,
        created: state.inventoryRepackages.created,
        isEditing: state.inventoryRepackages.isEditing,
        editError: state.inventoryRepackages.editError,
        edited: state.inventoryRepackages.edited,

        inventories: state.inventoryConverts.inventories,
        vendorIsLoading: state.inventories.isLoading,
        vendorError: state.inventories.error,
        userPermissions: state.auth.userPermissions
    }
}

export default connect(mapStateToProps, { createInventoryRepackage, editInventoryRepackage, fetchInventoryRepackageDetail, fetchInventories })(inventoryRepackageForm)



// WEBPACK FOOTER //
// ./master/jsx/containers/Inventories/inventoryRepackageForm.jsx